import Head from "next/head";
import { PrismicRichText } from "@prismicio/react";
import { Header } from "components/headers/Header";
import Footer from "components/footer/Footer";
import richTextComponents from "helpers/richTextComponents";

const DefaultTextPageTemplate = ({ page }) => {
  const { title, seo_description, subtitle, content } = page.data;

  return (
    <>
      <Head>
        <title>{title} | TopVakantiehuizen.eu</title>
        <meta name="description" content={seo_description} />
        <meta name="robots" content="all" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
      </Head>
      <Header />
      <main id="content">
        <div className="container pb-24 lg:pb-32">
          <header className="text-center max-w-2xl mx-auto mt-11 mb-10">
            <h1 className="flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              {title}
            </h1>
            {subtitle ? (
              <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
                {subtitle}
              </span>
            ) : (
              ""
            )}
          </header>
          <section className="container text-neutral-600 text-sm md:text-base overflow-hidden mb-10">
            <PrismicRichText field={content} components={richTextComponents} />
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default DefaultTextPageTemplate;
